import Perfom from "./routes/Perfom/Perfom.vue";
import Revenue from "./routes/Revenue/Revenue.vue";

const lockerDashboardRoutes = [
  {
    path: "perfom",
    name: "Perfom",
    component: Perfom,
  },
  {
    path: "revenue",
    name: "Revenue",
    component: Revenue,
  },
];

export default lockerDashboardRoutes;
